import Vue from '@/index.js'
import './category.scss'

import page from '@/mixins/page'
import ClickOutside from 'vue-click-outside'
export default new Vue({
  el: '#app',
  mixins: [page],
  components: {
    'layout-category-header': () => import('@/components/layout/category/layout-category-header.vue'),
    'layout-category-subcategories': () => import('@/components/layout/category/layout-category-subcategories.vue'),
    'layout-catalog-category-card': () => import('@/components/layout/catalog/layout-catalog-category-card.vue'),
    'layout-catalog-categories': () => import('@/components/layout/catalog/layout-catalog-categories.vue'),
    'layout-category-filter-list': () => import('@/components/layout/category/layout-category-filter-list.vue'),
    'layout-brands-carousel': () => import('@/components/layout/layout-brands-carousel.vue'),
    'layout-features': () => import('@/components/layout/layout-features.vue'),
    'layout-products-cached': () => import('@/components/layout/product/layout-products-cached.vue'),
    'layout-seo-blocks': () => import('@/components/layout/layout-seo-blocks.vue'),
    'layout-category-filters': () => import('@/components/layout/category/layout-category-filters.vue'),
    'layout-category-suggestions': () => import('@/components/layout/category/layout-category-suggestions.vue'),
    'layout-category-products': () => import('@/components/layout/category/layout-category-products.vue'),
    'layout-product-card': () => import('@/components/layout/product/layout-product-card.vue'),
    'layout-category-sidebar': () => import('@/components/layout/category/layout-category-sidebar.vue'),
    'ui-filter-select': () => import('@/components/ui/filter/ui-filter-select.vue'),
    'ui-filter-selected': () => import('@/components/ui/filter/ui-filter-selected.vue'),
    'ui-filter-checkbox': () => import('@/components/ui/filter/ui-filter-checkbox.vue'),
    'ui-filter-buttons': () => import('@/components/ui/filter/ui-filter-buttons.vue'),
    'layout-category-quick-sort': () => import('@/components/layout/category/layout-category-quick-sort.vue'),
      vueScroll: () => import('vuescroll'),
    'icon-arrow-dropdown': () => import('@/components/icon/icon-arrow-dropdown.vue'),
    'icon-delivery': () => import('@/components/icon/icon-delivery'),
    'icon-comment': () => import('@/components/icon/icon-comment'),
    'ui-arrow-button': () => import('@/components/ui/ui-arrow-button.vue'),
    'layout-index-carousel': () => import('@/components/layout/index/layout-index-carousel.vue'),
    'icon-cart': () => import('@/components/icon/icon-bag.vue')
  },
  directives: {
    ClickOutside
  },
})
